/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, PropsWithChildren } from 'react';
import TranslatedLabel from 'components/TranslatedLabel';
import { Tooltip } from 'antd';

export const HowItWorksTooltip: FC<PropsWithChildren> = ({ children }) => {
	return (
		<Tooltip
			title={
				<TranslatedLabel
					nameSpace='ad-management'
					i18nKey='form.bid.how_it_works'
				/>
			}
		>
			<span>
				<a>{children}</a>
			</span>
		</Tooltip>
	);
};
